<template>
  <section class="bg-white py-3">
    <div class="row">
      <div class="col-xl-6 col-md-12">
        <v-select
            v-if="getDDepartments"
            v-model="filter.parent"
            inputId="search.filter.parent"
            :options="getDDepartments"
            :reduce="item => item.id"
            placeholder="Привязано к"
            class="mb-5 bg-white"
            label="name"
        ></v-select>
      </div>
      <div class="col-xl-6 col-md-12">
        <v-select
            v-if="getDUsers"
            v-model="filter.head"
            inputId="search.filter.head"
            :options="getDUsers"
            :reduce="item => item.id"
            placeholder="Начальник"
            class="mb-5 bg-white"
            label="name"
        ></v-select>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-md-12">
        <div class="input-group input-group-sm mb-3">
          <input v-model="filter.title" type="text" class="form-control" name="filter.title" id="filter.title" placeholder="Название"/>
        </div>
      </div>
      <div class="col-xl-6 col-md-12">
        <v-select
            v-model="filter.type"
            :options="types"
            :reduce="item => item.id"
            inputId="search.filter.type"
            placeholder="Тип"
            class="mb-3 bg-white"
            label="name"
        ></v-select>
      </div>
    </div>
    <div class="row justify-content-between">
      <div class="col-xl-2 col-md-6">
        <button type="button" class="btn btn-block btn-light-warning btn-sm" @click="clear">Очистить</button>
      </div>
      <div class="col-xl-2 col-md-6">
        <button type="button" class="btn btn-block btn-primary btn-sm" @click="search">Поиск</button>
      </div>
    </div>
  </section>
</template>

<script>
import vSelect        from 'vue-select'

export default {
  name: 'BranchDepartmentsSearch',
  components: { vSelect },
  props: {
    filter: null
  },
  data() {
    return {
      types: [
          {id: 0, name: 'Нет 1C'},
          {id: 1, name: 'C 1C'},
          {id: 2, name: 'Локальный'},
      ]
    }
  },
  computed: {
    getDUsers()       { return this.$store.getters.getUsersDic },
    getDDepartments() { return this.$store.getters.getDepartmentsDic },
  },
  methods: {
    search() {
      this.$emit('search', true)
    },
    clear() {
      this.filter.parent = null
      this.filter.head   = null
      this.filter.type   = null
      this.filter.title  = ''
      this.$emit('search', true)
    }
  },
}
</script>

<style scoped>

</style>